const MAX_LOADING_ITEMS = 3;

export const getLoadingItemsCount = ({total, reportDataLength}: any) => {
  const leftItems = total - reportDataLength;

  return reportDataLength < total && leftItems >= MAX_LOADING_ITEMS
    ? MAX_LOADING_ITEMS
    : leftItems;
};
